import React from 'react'
import { observer } from 'mobx-react'
import { i18nTranslate } from 'src/utils'
import { Container, Row, Col } from 'react-bootstrap'
import isObject from 'lodash/isObject'
import { observable } from 'mobx'
import { loyaltyContainer } from 'src/models'
import { currencyFormat } from 'src/utils'
import { loyaltyRewards, locales } from './fixture'
import { MetaDecorator } from 'src/views/components'

@observer
class RewardsAndCredits extends React.Component {
  @observable loyaltyPoints = {}

  async componentDidMount() {
    this.loyaltyPoints = await loyaltyContainer.getLoyaltyPoints(true)
  }

  formatPrice = price => {
    const finalCost = currencyFormat({
      price,
    })
    return finalCost
  }

  renderTitle = key => {
    return (
      <Col xs={12} className="py-3 font-weight-bold text-center">
        {key === 'cycle'
          ? i18nTranslate('loyalty.cycleSummary', 'Cycle Summary')
          : i18nTranslate('loyalty.totalSummary', 'Total Summary')}
      </Col>
    )
  }

  getUpdatedList = () => {
    const updatedList = []
    updatedList.push({
      type: 'loyalty',
      properties: { rewardType: 'Earning Points' },
    })
    updatedList.push({
      type: 'Store Credit',
      properties: { rewardType: 'Store Credit' },
    })
    return updatedList
  }
  renderRewardAndCredits = () => {
    const userCredits = loyaltyContainer?.loyaltyResponse?.userMath || {}

    const updatedPaymentList = this.getUpdatedList()
    if (userCredits === undefined) {
      return (
        <span>
          {i18nTranslate(
            'rewards.emptyPage',
            'No rewards and credits available'
          )}
        </span>
      )
    }
    const view =
      updatedPaymentList &&
      updatedPaymentList.length > 1 &&
      updatedPaymentList.map(list => {
        const {
          type = '',
          properties: { rewardType = '' },
        } = list
        const userCreditAmount =
          userCredits && userCredits[rewardType]
            ? userCredits[rewardType].total.openToRedeem
            : 0.0

        const title = rewardType.toLowerCase()
        const subTitle = `${i18nTranslate('loyalty.available', 'Available')} ${
          locales[title.replace(/\s/, '')]
        }`
        const amount =
          type && type.toLowerCase() === 'loyalty'
            ? `${userCreditAmount} ${
                userCredits && userCredits[rewardType]
                  ? userCredits[rewardType].symbol
                  : ''
              }`
            : this.formatPrice(userCreditAmount)
        return (
          <Row
            noGutters
            key={title}
            className="w-100 pt-4 pb-5 px-5 bg-white mb-2">
            <Col
              style={{ fontSize: '1.2rem' }}
              className="reward-title text-capitalize font-weight-bold"
              xs={12}>
              {title}
            </Col>
            <Row noGutters className="w-100 pt-3 pb-3">
              <span
                style={{ fontSize: '1.12rem' }}
                className="reward-subTitle text-capitalize">
                {subTitle} :
              </span>
              <span
                style={{ fontSize: '1.2rem' }}
                className="reward-available-points pl-4">
                {amount}
              </span>
            </Row>
            <Row noGutters>
              <span>{i18nTranslate('loyalty.cycleDate', 'Cycle Date')} :</span>
              <span className="pl-4">
                {new Date(
                  loyaltyContainer?.loyaltyResponse?.cycleDate
                ).toDateString()}
              </span>
            </Row>
            <Row noGutters className="w-100">
              {isObject(userCredits[rewardType]) &&
                Object.entries(userCredits[rewardType]).map(data => {
                  const [key, value] = data
                  if (!['total', 'cycle'].includes(key)) {
                    return
                  }
                  return (
                    <Col key={key} xs={12} lg={6}>
                      {this.renderTitle(key)}
                      {loyaltyRewards().map(prop => {
                        return (
                          <Row
                            key={prop.key}
                            noGutters
                            className="pb-3 justify-content-between px-4">
                            <div>{prop.localeText}</div>
                            <div>{`${
                              rewardType === 'Store Credit'
                                ? this.formatPrice(value[prop.key])
                                : value[prop.key]
                            }`}</div>
                          </Row>
                        )
                      })}
                    </Col>
                  )
                })}
            </Row>
          </Row>
        )
      })
    return view
  }

  render() {
    const myAccountRewardAndCreditsTitle = i18nTranslate(
      'myAccountRewardAndCreditsPage.title',
      'Rewards and Credits | Nu Skin'
    )
    return (
      <>
        <MetaDecorator
          title={myAccountRewardAndCreditsTitle}
          imageUrl=""
          imageAlt=""
          description="Rewards and Credits page"
          location={this.props}
        />
        <Container className="w-100 h-auto p-3">
          {this.renderRewardAndCredits()}
        </Container>
      </>
    )
  }
}

export { RewardsAndCredits }

export default RewardsAndCredits
